import React from "react";
import { Paper, Grid, Container, Typography } from "@mui/material";
import styled from "@mui/system/styled";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Tags from "./tags";
import CCLicence from "./cc";
import Contributers from "./contributers";
import FileInfo from "./fileinfo";
import DownloadItem from "./downloaditem";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const PageWrapper = styled("div")({
  height: "auto",
  position: "relative",
});

const BackWrapper = styled("div")({
  position: "relative",
  top: "15px",
  left: "0",
});

const ContributerWrapper = styled("div")`
  padding-bottom: 8px;
`;

const FileItemWrapper = styled("div")`
  text-align: left;
`;

const Img = styled("img")`
  max-width: 100%;
  margin: 15px 0;
`;

const createMarkup = (html) => {
  return { __html: html };
};

export const GDLFileItem = ({ item, nonce = null, loadFile = null, context }) => {
  const [downloads, setDownloads] = React.useState([]);
  const {
    topic,
    title,
    alt,
    h5pUrl,
    thumbnail,
    description,
    license = null,
    contributers = [],
  } = item;

  const tags = topic.map(t => t.name)
  const handleDownload = async (fileItem) => {
    setDownloads([...downloads, fileItem.postId]);
    const fileTarget = { 
      id: item.postId,
      url: fileItem.h5pUrl,
      refId: item.bookId,
      h5pId: item.h5pId,
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": nonce,
      },
      body: JSON.stringify({ file: fileTarget }),
    };

    await fetch("/?rest_route=/edupix_restapi/v1/addh5pfile", options)
      .then((response) => response.json())
      .then((data) => {
        // TODO: handle errors
        // checked? Confirm download etc.
        setDownloads([
          ...downloads.filter((f) => f !== fileItem.postId),
        ]);
      });
  };

  return (
    <PageWrapper>
      <Container fixed>
        <BackWrapper>
          <Button onClick={() => history.go(-1)} startIcon={<ArrowBack />}>
            Back
          </Button>
        </BackWrapper>
        <Grid mt={5} container spacing={2}>
          <Grid item xs={8}>
            <Item>
              <Typography
                variant="h5"
                component="h2"
                dangerouslySetInnerHTML={createMarkup(title)}
              />
              {thumbnail && (
                <Img
                  src={thumbnail}
                  loading="lazy"
                  alt={alt && alt !== "" ? alt : title}
                  crossOrigin="anonymous"
                  referrerPolicy="no-referrer"
                />
              )}

              {description &&
                <>
                  <div style={{textAlign: "left"}}>
                    <Typography variant="paragraph" align="left">
                      {item.description}
                    </Typography>
                  </div>
                </>
              }
              {tags && tags.length && <Tags tags={tags} />}
              {license && <CCLicence license={Array.isArray(license) ? license[0].name : license} />}
            </Item>
          </Grid>
          <Grid item xs={4}>
            <Item>
              {item && (
                <FileItemWrapper>
                  <Typography variant="h4" component="h1">
                    {item.author}
                  </Typography>
                  <FileInfo
                    fileTitle={title}
                    fileType="H5P"
                    // fileRef={item.ref}
                    filePublisher={item.publisher}
                  /> 
                  {contributers && contributers.length > 0 && (
                    <ContributerWrapper>
                      <Contributers contributers={item.contributers} />
                    </ContributerWrapper>
                  )}
                  <DownloadItem
                    fileItem={h5pUrl}
                    buttonText="Add file to library"
                    // onDownload={handleDownload}
                    onDownload={() =>
                      handleDownload(item)
                      // console.log('lets get it..', fileItem)
                    }
                    isDownloading={downloads.includes(
                      item.postId
                    )}
                    /> 
                </FileItemWrapper>
              )}
            </Item>
          </Grid>
        </Grid>
      </Container>
    </PageWrapper>
  );
};
